import React from 'react';
import FieldDataModel from '../../models/FieldDataModel';
import { unslugFieldName } from '../../pullConfigManager';

export interface FieldSelectOption {
  label: string;
  value: string;
  isDisabled?: boolean;
  notSynced?: boolean;
}

/**
 * react-select options for a conversion field dropdown. Fields whose column
 * has not landed in Redshift (isAvailable: false) are unselectable: the
 * publish would fail at the script-checker step with "column does not exist"
 * (RGI-2349).
 */
export function toFieldSelectOptions(
  fields: FieldDataModel[]
): FieldSelectOption[] {
  return fields.map(({ name, isAvailable }) => ({
    label: unslugFieldName(name),
    value: name,
    isDisabled: isAvailable === false,
    notSynced: isAvailable === false,
  }));
}

const NOT_SYNCED_BADGE_STYLE: React.CSSProperties = {
  marginLeft: '8px',
  padding: '1px 6px',
  borderRadius: '4px',
  border: '1px solid #fcd34d',
  backgroundColor: '#fffbeb',
  color: '#b45309',
  fontSize: '10px',
  fontWeight: 500,
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
};

export function formatFieldOptionLabel(
  option: FieldSelectOption
): React.ReactNode {
  if (!option.notSynced) {
    return option.label;
  }
  return (
    <span title="This field is not synced to your warehouse yet. Add it in the integration's Pull tab.">
      {option.label}
      <span style={NOT_SYNCED_BADGE_STYLE}>Not synced</span>
    </span>
  );
}
